import { render } from "solid-js/web";
import { Designer } from "./components/design";

render(Designer, document.getElementById("main"));
